import React from "react";
import {
  MDBTabContent,
  MDBContainer,
  MDBNav,
  MDBNavItem,
  MDBNavLink,
  MDBTabPane,
  MDBRow,
  MDBCol,
  MDBListGroup,
  MDBListGroupItem,
  MDBCard,
  MDBView,
  MDBCardBody,
  MDBTable,
  MDBIcon,
  MDBBadge,
} from "mdbreact";
import "../components/styles/NavBar.css";
import FooterPage from "../components/FooterPage";
import url from "../components/config/Config";
import { formatHumansBs, formatHumansDate } from "../helpers/formatHuman";
import ModalOrderDetails from "../components/orders/ModalOrderDetails";

class Pedido extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeItemOuterTabs: "1",
      lista: [],
      llave: "",
      correo: "",
      idcliente: "",
      listaPedido: [],
      detalleidpedido: 0,
      detallefecha: "",
      detalleestado: "",
      detalletotal: "",
      
      listaDetallePedido: [],
      modalStateOrderDetails: false
    };
    if (localStorage.getItem("LoginJucumari")) {
      let l = JSON.parse(localStorage.getItem("LoginJucumari"));
      if (l.length > 0) {
        this.state.llave = l[0].llave;
        this.state.correo = l[0].correo;
        this.state.idcliente = l[0].idcliente;
      }
    }
    this.listarPedidos();
  }

  listarPedidos() {
    //console.log("URL : "+url.service+'pedido')
    let datos = {
      accion: "pedidoCliente",
      llave: this.state.llave,
      idcliente: this.state.idcliente,
    };
    //console.log(datos)
    fetch(url.service + "pedido", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(datos),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        this.setState({ listaPedido: Array.from(responseJson) });
        //console.log(this.state.listaPedido)
      });
  }

  verDetallePedido(idventa) {
    let datos1 = {
      accion: "ListarDetalleVenta",
      llave: this.state.llave,
      idventa: idventa,
    };
    fetch(url.service + "detalleVenta", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(datos1),
    })
      .then((response) => response.json())
      .then((responseJson) => {
    
        this.setState({ modalStateOrderDetails: true });
        this.setState({ listaDetallePedido: Array.from(responseJson) });
      });
  }
  
  changeStateModalOrderDetails = () => {
    this.setState({ modalStateOrderDetails: false });
  };

  render() {
    return (
      <div style={{ margin: "50px 0 0 0" }}>
        <MDBContainer className="max-w-7xl mx-auto">
          <MDBCard narrow className="pb-3">
            <MDBView
              cascade
              className="bg-gradient-to-r from-[#6b306e] to-[#9b4fa0] narrower py-2 mx-4 mb-3 flex justify-between items-center"
            >
              <p className="white-text font-weight-bold mx-3 h4-responsive">
                Tabla pedidos
              </p>
            </MDBView>
            <MDBCardBody>
              <MDBTable responsive hover>
                <thead>
                  <tr>
                    <th className="th-lg font-weight-bold">Número de pedido</th>
                    <th className="th-lg font-weight-bold">Fecha</th>
                    <th className="th-lg font-weight-bold">Total</th>
                    <th className="th-lg font-weight-bold">Estado</th>
                    <th className="th-lg font-weight-bold">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.listaPedido.map((item, key) => {
                    return (
                      <tr key={item.idventa}>
                        <td className="font-weight-bold">{item.idpedido}</td>
                        <td>{formatHumansDate( item.fecha )}</td>
                        <td className="text-muted">
                          {" "}
                          {formatHumansBs(item.total)}{" "}
                        </td>
                        <td className="green-text">
                          <MDBBadge className="p-2 bg-secondary-personalize" pill color="">
                            {item.estado}
                          </MDBBadge>
                        </td>
                        <td className="text-muted">
                          <span
                            onClick={() => this.verDetallePedido(item.idventa)}
                            style={{ cursor: "pointer" }}
                          >
                            <i className="fa fa-eye"></i>
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </MDBTable>
            </MDBCardBody>
          </MDBCard>
        </MDBContainer>
        <ModalOrderDetails 
          modalStateOrderDetails={ this.state.modalStateOrderDetails } 
          changeStateModalOrderDetails={this.changeStateModalOrderDetails} 
          listaDetallePedido={ this.state.listaDetallePedido }
        />
        <FooterPage />
      </div>
    );
  }
}
export default Pedido;
